
export enum Origin{
    Left='left',
    Right='right',
    Center='center'
}